/**
 * Single source of truth for per-podcast configuration.
 * To spin up a new podcast site: change the values below and set FEED_URL,
 * then run `yarn feed && yarn build`. Nothing else needs to change.
 */
export const siteConfig = {
  brand: "WVEdChat",
  domain: "https://wvedchat.com",
  feedUrl: "https://podcasts.johnscreekstudios.com/wvedchat/feed.xml",
  tagline: "Conversations Along the Road of West Virginia Education",

  nav: [
    { label: "Home", to: "/" },
    { label: "Episodes", to: "/episodes" },
    { label: "About", to: "/about" },
    { label: "Follow", to: "/follow" },
    { label: "Support", to: "/support" },
    { label: "Contact", to: "/contact" },
  ],

  /**
   * Follow / Listen platforms. Icons (TeamPodlink set) are served from the John's Creek Studios CDN.
   * WVEdChat is new, so directory links are not set up yet. Add entries here as the show
   * is approved in each directory, for example:
   *   {
   *     name: "Apple Podcasts",
   *     url: "https://podcasts.apple.com/us/podcast/wvedchat/id<ID>",
   *     icon: "https://cdn.johnscreekstudios.com/badges/apple.svg",
   *   },
   * Badge icons available on the CDN: apple, spotify, overcast, pocketcasts, castbox,
   * castro, podcastguru, podverse, truefans, podcastindex, podlink (all .svg).
   * While this list is empty the Follow page shows just the RSS feed.
   */
  follow: [],

  about: {
    headline: "Conversations along the road of West Virginia education.",
    body: [
      "WVEdChat is where we sit down with the people shaping West Virginia education — teachers, administrators, students, parents, community leaders, and policymakers — for thoughtful conversations about the issues, challenges, ideas, and experiences that matter to communities across the Mountain State.",
      "Each episode is a candid interview that goes beyond the headlines to explore current issues, share experiences, and hear perspectives on where West Virginia education is today and where it may be headed.",
    ],
    host: {
      name: "Randy Black",
      role: "Host — Educator & Podcaster",
      link: "https://randallblack.com",
      bio: [
        "Randy Black is an educator and podcaster who hosts WVEdChat to spotlight the people and ideas shaping West Virginia schools and communities.",
        "Drawing on years in the classroom and behind the mic, Randy brings curiosity and candor to every conversation, making big education topics accessible without dumbing them down.",
      ],
    },
  },

  support: {
    /** Shared podcast-support Stripe Worker endpoint for this show (the show must be added in the podcast-support app) */
    apiBase: "https://podcast-support.randy-8c6.workers.dev/v1/wvedchat",
    /** Widget colors, matched to the light cream/navy/gold theme */
    theme: {
      primary: "#f5b61c",
      onPrimary: "#0a1630",
      accent: "#f5b61c",
      accentStrong: "#dda00d",
      accentSoft: "rgba(245, 182, 28, 0.22)",
      onAccent: "#0a1630",
      link: "#8a5a00",
      text: "#0b1f4d",
      textMuted: "#4d5a78",
      textFaint: "#66718d",
      border: "rgba(11, 31, 77, 0.18)",
      track: "rgba(11, 31, 77, 0.07)",
    },
    blurb:
      "WVEdChat is independent and listener-supported. If these conversations are valuable to you, chipping in helps keep new episodes coming — no ads, no gatekeepers.",
  },

  contact: {
    blurb:
      "Have a guest suggestion, a topic for the show, or a story from your corner of West Virginia education? Reach out — the door's always open.",
  },
};

export default siteConfig;
